module.exports = "<div class=\"table-header-action flex-item item-center\">\n\t<h3 class=\"heading-3 m-0\">Bank Institutions</h3>\n    <button (click)=\"openAddBankInstitutionDialog()\" md-raised-button class=\"btn-secondary\">\n    \t<i class=\"material-icons\">add</i> New Bank Institution</button>\n</div>\n\n<app-bankinstitution-list #bankinstitutions>Loading...</app-bankinstitution-list>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/finance/bankinstitutions/bankinstitutions.component.html
// module id = 2304
// module chunks = 0